import { DesktopAppBar, IconButton, iconSizes, useBrand } from '@common/ui'
import { IconMenu2 } from '@common/ui/icons'
import { com } from '@eidu/web'
import { useCompactNavigation } from './CompactNavigationContext'
import ActionsMenu from './ActionsMenu'
import ImpersonationChip from './ImpersonationChip'
import EntityId = com.eidu.entity.EntityId

export type TopAppBarProps = {
  userEntityId: EntityId | undefined
  signOut?: () => void
}

const TopAppBar = ({ userEntityId, signOut }: TopAppBarProps) => {
  const { isCompact, toggleDrawer } = useCompactNavigation()
  const { logo } = useBrand()

  const menuButton = (
    <IconButton aria-label="Toggle navigation menu" onClick={toggleDrawer} size="lg" c="var(--trellis-color-on-accent)">
      <IconMenu2 size={iconSizes.sm} stroke={1.5} />
    </IconButton>
  )

  return (
    <DesktopAppBar
      leading={isCompact ? menuButton : logo}
      center={isCompact ? logo : undefined}
      trailing={
        <>
          <ImpersonationChip />
          <ActionsMenu userEntityId={userEntityId} signOut={signOut} />
        </>
      }
    />
  )
}

export default TopAppBar
